var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"family-list container"},[(_vm.isAdmin)?_c('breadcrumbs',{attrs:{"breadcrumb-links":[
      {url:_vm.userHomeURL, text: 'Admin home'},
      {url:_vm.addFamilyURL, text: 'Add families'},
      {text: 'Recipient list'}
    ]}}):_c('breadcrumbs',{attrs:{"breadcrumb-links":[
      {url:_vm.userHomeURL, text: 'Home'},
      {text: 'Recipient list'}
    ]}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"card col-12"},[_c('h2',[_vm._v("View recipients list")]),_c('p',[_vm._v("Recipients are listed below, potential duplicates in our system are flagged for review.")]),(_vm.hasDuplicates)?_c('warning-message'):_vm._e(),_c('family-table')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }